const $$splitErrorComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/iframe-api/studio/record-video.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/iframe-api/studio/record-video.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { type FormSubmitProps } from '@/Components/studio';
import { type Media_UploadVideoPost_Mutation$data } from '@/graphql/mutations/Media.mutation';
type MessageToIframe = {
  type: 'znrv.ready';
} | {
  type: 'znrv.close';
} | {
  type: 'znrv.video-ready';
  payload: {
    data?: Media_UploadVideoPost_Mutation$data['uploadVideoPost'];
    errors?: string[];
  };
};
export type { MessageToIframe as RecordVideoIframeMessage };
export const Route = createFileRoute('/iframe-api/studio/record-video')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});